export default __webpack_public_path__ + "static/media/NEAS0590.34I-38054_-22426_0.1c1e8f94.jpg";